import { Actions, defaultEmployee } from './constants';
import { ActionsType, Employee, EmployeeState } from './types';
import { Reducer } from 'redux';

const initialState: EmployeeState = {
  list: [],
  isLoading: false,
  error: undefined,
  selectedEmployee: defaultEmployee,
};

const employeeReducer: Reducer<EmployeeState, ActionsType> = (
  state = initialState,
  action,
): EmployeeState => {
  switch (action.type) {
    case Actions.GET_EMPLOYEE_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      };
    case Actions.GET_EMPLOYEE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.GET_EMPLOYEE_BY_ID_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_EMPLOYEE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedEmployee: action.payload,
        error: undefined,
      };
    case Actions.GET_EMPLOYEE_BY_ID_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.EDIT_EMPLOYEE_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.EDIT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: state.list.map((item) => {
          if (item._id === action.payload.id) {
            return { ...item, ...action.payload.body };
          }
          return item;
        }),
        error: undefined,
        selectedEmployee: action.payload.body,
      };
    case Actions.EDIT_EMPLOYEE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.SET_SELECTED_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: action.payload,
      };
    case Actions.CLEAN_SELECTED_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: {} as Employee,
      };

    default:
      return state;
  }
};

export default employeeReducer;
